import { OperationResult } from '@vp/common/core/OperationResult';
import { SubmitEventsResultDto } from '@vp/manager/events/core/dto/SubmitEventsResultDto';
import { SumbitEventsDto } from '@vp/manager/events/core/dto/SumbitEventsDto';
import { EventsManagerRecordModel } from '@vp/manager/events/core/model/EventsManagerRecordModel';

export abstract class EventsManagerRepository {
  abstract loadEvents(profileId: string, controller: AbortController): Promise<OperationResult<EventsManagerRecordModel[]>>;
  abstract submitEvents(dto: SumbitEventsDto, controller: AbortController): Promise<OperationResult<SubmitEventsResultDto>>;
}
